<template>
  <div class="wrap">
    <headTop></headTop>
    <!-- 中间内容 -->
    <div class="specialistContent">
      <div style="padding:0.1em 3em;">
        <!-- 左侧菜单栏 -->
        <div class="box">
          <div class="specialistContent_left">
            <div class="specialistContent_left_title">专员风采</div>
            <div
              class="bG"
              v-for="(item,index) in leftMenu1"
              :key="index"
              :class="{active: toggle == item.name}"
              @click="changeDetail(item)"
            >{{item.name}}</div>
            <div
              class="bG"
              v-for="(item) in leftMenu2"
              :key="item.id"
              :class="{active: toggle == item.name}"
              @click="changeDetail(item)"
            >{{item.name}}</div>
          </div>
          <!-- 右侧内容 -->
          <div class="specialistContent_right">
            <div class="specialistContent_right_title">
              <div class="title">{{toggle}}</div>
            </div>
            <div class="serviceContent">
              <h4>科室成员</h4>
              <div class="itemCenter">
                <div class="serviceContentItem" v-for="item in serviceContent" :key="item.introduceId" @click="goToDetail(item.id)">
                  <div class="itemTop">
                    <img :src="$store.getters.imgUrl+item.avatar" alt  v-if="item.avatar"/>
                     <img src="@/assets/image/specialistCenter/headPortrait.png" alt v-else />
                    <div>
                      <span>{{item.name}}</span>
                      <span style=" font-size: 0.8em !important; color:#2579BF;font-weight:500">{{item.officeNameStr}}</span>
                    </div>
                  </div>
                  <div class="itemBottom">
                    <span>{{item.introduceContent}}</span>
                  </div>
                </div>
                <div
                  v-show="serviceContent.length%3>0"
                  v-for="item in (3-serviceContent.length%3)"
                  :key="item"
                  class="serviceContentItem"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <footCode></footCode>
      </div>
    </div>
  </div>
</template>
<script>
import footCode from "../../components/footCode";
import headTop from "../../components/HeadTop";
export default {
  name: "savant",
  components: {
    footCode,
    headTop,
  },
  data() {
    return {
      leftMenu1: [],
      leftMenu2: [],
      officeId: "",
      toggle: "环境政策咨询科",
      imgUrl: "",
      serviceContent: [], //服务内容
    };
  },
  mounted() {
    this.toggle = this.$route.query.name;
    this.getCenterList();
  },
  methods: {
    idxActiveFun(_idx) {
      this.idxActive = _idx;
    },
    // 获取中心列表
    getCenterList() {
      this.ajaxUtil({
        method: "get",
        url: this.$store.state.axiosUrl + "/api/home/getAllOffice",
      }).then((res) => {
        this.leftMenu1 = res.data.filter((item) => {
          return item.type == 1;
        });
        this.leftMenu2 = res.data
          .filter((item) => {
            return item.type == 2;
          })
          .splice(0, 2);
        this.toggle = "环境政策咨询科";
        this.officeId = this.leftMenu1[0].id;
        this.getCenterListDetail();
      });
    },
    //获取中心列表详情
    getCenterListDetail() {
      this.ajaxUtil({
        method: "get",
        url:
          this.$store.state.axiosUrl +
          `/api/home/getExpertListByOfficeId?officeId=${this.officeId}`,
      }).then((res) => {
        this.serviceContent = res.data;
      });
    },
    // 切换
    changeDetail(item) {
      this.toggle = item.name;
      this.officeId = item.id;
      this.getCenterListDetail();
    },
    //详情
    goToDetail(id){
        this.$router.push({
        path: "/savant/detail",
        query: {
          id
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
// @import url('~@/assets/css/index.less');
.wrap {
  display: flex;
  flex-direction: column;
  min-width: 12.8em;
  // box-sizing: border-box;
}
.specialistContent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  // overflow: auto;
  background: #e9f0f6;
  // padding: 0.1em 3em;
  .specialistContent_left {
    font-size: 0.17em;
    color: #333;
    div {
      padding: 0.6em 1em;
      text-align: center;
      background-color: #d6f0f6;
      margin-top: 0.08em;
      cursor: pointer;
      font-size: 0.85em;
      width: 200px;
    }
    .specialistContent_left_title {
      background: radial-gradient(circle, #3cc9e4 0%, #2579bf 100%);
      color: #fff;
      padding: 0.6em;
      //   width: 15em;
      font-size: 1em;
    }
    .bG:hover{
      color: #2579bf;
      background-color: #fff;
    }
    .active {
      color: #2579bf;
      background-color: #fff;
      border-left: 0.5em solid #2579bf;
    }
  }
  .specialistContent_right {
    color: #333;
    margin-left: 2em;
    margin-top: 0.1em;
    font-size: 0.18em;
    flex: 1;
    .specialistContent_right_title {
      font-size: 0.2em;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 1em;
      border-bottom: 1px solid #e5e5e5;
      div {
        padding-bottom: 1em;
      }
      .title {
        color: #2579bf;
        font-size: 16px;
        padding-bottom: 5px;
        border-bottom: 4px solid #2579bf;
      }
    }
    .imgBox {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 0em;
      img {
        height: 12em;
        width: 45em;
      }
    }
  }
}
.footer {
  width: 100%;
  margin-top: 0.2em;
}
.titlePosition {
  font-size: 0.15em;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  color: #666;
}
.box {
  display: flex;
}
.itemCenter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.serviceContentItem {
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-top: 20px;
  cursor: pointer;
  img {
    height: 5em;
    width: 5em;
    border-radius: 50%;
  }
  .itemTop{
      display: flex;
      align-items: center;
      div{
          display: flex;
        //   align-items: center;
          flex-direction: column;
          margin-left: 20px;
          span{
              color: #333;
              font-weight: 600;
              font-size: 1em;
              margin-bottom: 0.4em;
          }
      }
  }
  .itemBottom{
      color: #666;
      font-size: 0.7em;
      margin-top: 0.5em;
  }
}
h4{
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/savant/index.vue